module.exports = __webpack_public_path__ + "static/media/Observations.6d65dc57.png";